"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8768],{

/***/ 35035:
/***/ (function(module) {



module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),

/***/ 76844:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var void_1 = __importDefault(__webpack_require__(22623));
/**
 * List of tags having optional closing tag
 */
var optionalVoidHtmlTags = [
    'li',
];
var min = Math.min, max = Math.max;
var HtmlSubstringError = /** @class */ (function (_super) {
    __extends(HtmlSubstringError, _super);
    function HtmlSubstringError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HtmlSubstringError;
}(Error));
var DEFAULT_OPTIONS = {
    breakWords: true,
    suffix: null,
};
var isLetter = function (input) {
    return input && input.toLowerCase() !== input.toUpperCase();
};
var isNumber = function (input) {
    return '0123456789'.indexOf(input) !== -1;
};
var isWhitespace = function (input) {
    return ' \t\r\n'.indexOf(input) !== -1;
};
var isVoidTag = function (tag) { return void_1.default.indexOf(tag) !== -1; };
var isOptionalVoidTag = function (tag) { return optionalVoidHtmlTags.indexOf(tag) !== -1; };
var haveToHaveClosingTag = function (tag) { return !(isVoidTag(tag) || isOptionalVoidTag(tag)); };
/**
 * @param source Source HTML
 * @param length Visible characters (everything but HTML tags) limit
 * @param options Options object
 *
 * @returns stripped source by length characters
 */
function html_substring(source, length, options) {
    if (options === void 0) { options = DEFAULT_OPTIONS; }
    var opts;
    if (typeof options === 'string') {
        opts = __assign({}, DEFAULT_OPTIONS, { suffix: options });
    }
    else {
        opts = __assign({}, DEFAULT_OPTIONS, options);
    }
    var current = 0; // current text length
    var i = 0; // current source position
    var chars = Array.from(source); // Split the string to array of characters
    var openTag = function () {
        var tag = '';
        var other = '';
        var c = '';
        var tagStart = i;
        while (i < chars.length) {
            c = chars[i++];
            if (!isLetter(c) && !isNumber(c)) {
                break;
            }
            tag += c;
        }
        if (tag.length > 0 && i < chars.length && c !== '>') {
            other += c;
            while (i < chars.length) {
                c = chars[i++];
                if (c === '>') {
                    break;
                }
                other += c;
            }
        }
        if (tag.length === 0 || c !== '>') {
            cw.push('<');
            i = tagStart;
            return null;
        }
        return [tag, other];
    };
    var closeTag = function () {
        var tag = '';
        var c;
        while (i < chars.length) {
            c = chars[i++];
            if (c === '>') {
                break;
            }
            tag += c;
        }
        return tag;
    };
    var c; // current character
    var openedQueue = []; // nonflushed open tags
    var closeQueue = []; // list of tags to be closed
    var result = '';
    var openTags = function (onlyVoid) {
        if (onlyVoid === void 0) { onlyVoid = false; }
        while (true) {
            var value = openedQueue.shift();
            if (!value) {
                break;
            }
            var tag = value[0], other = value[1];
            var isVoid = isVoidTag(tag);
            var isOptionalVoid = isOptionalVoidTag(tag);
            var isXHTMLClosed = other[other.length - 1] === '/';
            if (onlyVoid && !(isVoid || isXHTMLClosed)) {
                openedQueue.unshift([tag, other]);
                break;
            }
            result += '<';
            result += tag;
            result += other;
            result += '>';
            if (!(isVoid || isOptionalVoid || isXHTMLClosed)) {
                closeQueue.push("</" + tag + ">");
            }
        }
    };
    var cw = []; // current word
    var cwEmpty = true;
    var flushWord = opts.breakWords
        ? function () {
            if (cw.length === 0) {
                return true;
            }
            var addable = max(min(length - current, cw.length), 0);
            if (addable === 0) {
                return false;
            }
            openTags();
            result += cw.slice(0, addable).join('');
            current += addable;
            cw.splice(0, addable);
            return true;
        }
        : function () {
            if (cw.length === 0) {
                return true;
            }
            if (current + cw.length <= length) {
                openTags();
                result += cw.join('');
                current += cw.length;
                cw.length = 0;
                return true;
            }
            return false;
        };
    mainloop: while (current < length && i < chars.length) {
        c = chars[i++];
        switch (c) {
            case '<':
                if (!flushWord()) {
                    break mainloop;
                }
                // there's tag
                switch (chars[i]) {
                    case '!': {
                        if (chars[i + 1] === '-' && chars[i + 2] === '-') {
                            // comment
                            i += 2;
                            while (chars[i] !== '-' &&
                                chars[i + 1] !== '-' &&
                                chars[i + 2] !== '>') {
                                ++current;
                                result += chars[i++];
                            }
                            i += 2;
                        }
                        else {
                            ++current;
                            result += '<';
                        }
                        break;
                    }
                    case '/': {
                        // We should flush opened tags queue since we are going to close a tag just now
                        openTags();
                        var offset_1 = i - 1;
                        ++i;
                        var tag = closeTag();
                        var success = false;
                        // if the tag doesn't need to be closed, then just print it
                        if (haveToHaveClosingTag(tag)) {
                            while (closeQueue.length !== 0) {
                                success = closeQueue.pop() === ("</" + tag + ">");
                                if (success) {
                                    break;
                                }
                            }
                            if (!success) {
                                throw new HtmlSubstringError("Unexpected closing tag '" + tag + "' on offset " + offset_1);
                            }
                        }
                        result += '</';
                        result += tag;
                        result += '>';
                        break;
                    }
                    default: {
                        // open tag
                        var tag = openTag();
                        if (tag !== null) {
                            openedQueue.push(tag);
                        }
                        break;
                    }
                }
                break;
            case '&':
                flushWord();
                var offset = i - 1;
                result += '&';
                ++current;
                while (i < chars.length) {
                    var c_1 = chars[i++];
                    // result += c
                    if (isWhitespace(c_1)) {
                        i = offset + 1;
                        break;
                    }
                    if (c_1 === ';') {
                        result += chars.slice(offset + 1, i).join('');
                        break;
                    }
                }
                break;
            default:
                if (!isLetter(c) && !cwEmpty) {
                    cwEmpty = true;
                    if (!flushWord()) {
                        break mainloop;
                    }
                }
                if (!isWhitespace(c)) {
                    cwEmpty = false;
                }
                cw.push(c);
        }
    }
    openTags(true);
    var flushed = flushWord();
    closeQueue.reverse();
    result = [result].concat(closeQueue).join('');
    if (!flushed) {
        var suffix = opts.suffix;
        if (suffix !== null) {
            if (typeof suffix === 'function') {
                suffix = suffix();
            }
            result += suffix;
        }
    }
    return result;
}
exports.html_substring = html_substring;
exports["default"] = html_substring;


/***/ }),

/***/ 22623:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


module.exports = __webpack_require__(14666);


/***/ }),

/***/ 13890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var InputRadio = function(props) {
    var input = props.input, _meta = props.meta, touched = _meta.touched, error = _meta.error;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "Form-checkbox flex items-center ".concat(props.className ? props.className : "", " ").concat(props.disabled ? "disabled" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", _objectSpread({}, input, {
                    id: props.id,
                    type: "radio",
                    disabled: props.disabled,
                    className: "checkbox-input opacity-0 w-0 h-0 ".concat(touched && error ? "error" : "")
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "checkbox-control is-radio flex-none w-5 h-5 p-1 mr-2 border-gray-1600 hover:border-black border rounded-full bg-white ".concat(props.required ? "is-required" : ""),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "10",
                        height: "10",
                        viewBox: "0 0 10 10",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "10",
                            height: "10",
                            rx: "5",
                            fill: "#319D10"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "inline-block leading-18.2 ".concat(props.labelClass),
                    children: typeof props.label === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        dangerouslySetInnerHTML: {
                            __html: props.label
                        },
                        className: "inline-block"
                    }) : props.label
                })
            ]
        })
    }));
};
InputRadio.defaultProps = {
    disabled: undefined
};
/* harmony default export */ __webpack_exports__["Z"] = (InputRadio);


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);



function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var withRouterPageLayout = function(ComposedComponent) {
    var WithRouteWrapper = /*#__PURE__*/ function(Component1) {
        "use strict";
        _inherits(WithRouteWrapper, Component1);
        var _super = _createSuper(WithRouteWrapper);
        function WithRouteWrapper() {
            _classCallCheck(this, WithRouteWrapper);
            return _super.apply(this, arguments);
        }
        _createClass(WithRouteWrapper, [
            {
                key: "render",
                value: function render() {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComposedComponent, _objectSpread({
                        router: this.context.router
                    }, this.props)));
                }
            }
        ]);
        return WithRouteWrapper;
    }(react__WEBPACK_IMPORTED_MODULE_1__.Component);
    _defineProperty(WithRouteWrapper, "contextTypes", {
        router: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().object)
    });
    WithRouteWrapper.getInitialProps = ComposedComponent.getInitialProps;
    // Hoists non standard static properties
    WithRouteWrapper.pageLayout = ComposedComponent.pageLayout;
    WithRouteWrapper.layoutProps = ComposedComponent.layoutProps;
    WithRouteWrapper.pageName = ComposedComponent.pageName;
    return WithRouteWrapper;
};
/* harmony default export */ __webpack_exports__["Z"] = (withRouterPageLayout);


/***/ }),

/***/ 34611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Support_ArticleCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./node_modules/html-substring/lib/main.js
var main = __webpack_require__(76844);
var main_default = /*#__PURE__*/__webpack_require__.n(main);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./containers/Support/Feedback.js + 1 modules
var Feedback = __webpack_require__(21260);
// EXTERNAL MODULE: ./components/Heading.js
var Heading = __webpack_require__(73510);
// EXTERNAL MODULE: ./components/Icons/ArrowDown.js
var ArrowDown = __webpack_require__(26206);
;// CONCATENATED MODULE: ./components/FadeoutContainer.js

var FadeOutContainer = function(param) {
    var isFadeVisibile = param.isFadeVisibile, children = param.children;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            !isFadeVisibile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute bottom-0 bg-gradient-to-t from-white to-transparent h-16 w-full"
            }),
            children
        ]
    });
};
/* harmony default export */ var FadeoutContainer = (FadeOutContainer);

;// CONCATENATED MODULE: ./containers/Support/ArticleCard.js









function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var Button = function(param) {
    var onClick = param.onClick, hidden = param.hidden;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("button", {
        onClick: onClick,
        className: "flex items-center pt-3 text-secondary outline-none",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mr-2 h-20px text-14px -tracking-0.29 underline",
                children: hidden ? "Extinde articolul" : "Restrange articolul"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "".concat(!hidden ? "rotate-180" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: "9px",
                    height: "9px"
                })
            })
        ]
    });
};
var ArticleCard = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(ArticleCard, Component1);
    var _super = _createSuper(ArticleCard);
    function ArticleCard() {
        _classCallCheck(this, ArticleCard);
        var _this;
        _this = _super.apply(this, arguments);
        _defineProperty(_assertThisInitialized(_this), "state", {
            hidden: true
        });
        _defineProperty(_assertThisInitialized(_this), "toggleContent", function() {
            _this.setState(function(prevState) {
                return {
                    hidden: !prevState.hidden
                };
            });
        });
        return _this;
    }
    _createClass(ArticleCard, [
        {
            key: "render",
            value: function render() {
                var item1 = this.props.item;
                var hidden = this.state.hidden;
                if (!item1) {
                    return null;
                }
                var maxLength = 510;
                var showButton = item1.content.replace(/<[^>]*>?/gm, "").length > maxLength;
                var content = hidden && showButton ? "".concat(main_default()(item1.content, maxLength)) : item1.content;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                    className: "mb-12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                            title: item1.title,
                            as: "h2",
                            classesProp: "mb-3"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FadeoutContainer, {
                                    isFadeVisibile: showButton && !hidden || !showButton,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "Cms",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            dangerouslySetInnerHTML: {
                                                __html: content
                                            }
                                        })
                                    })
                                }),
                                (showButton && !hidden || !showButton) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        item1.tags && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "pt-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-wrap -ml-2",
                                                children: item1.tags.map(function(item) {
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                                        href: "".concat(settings.baseUrl, "/suport-clienti/cauta/?ts=").concat(encodeURIComponent(item.title)),
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "ml-2 mb-2 px-2 py-1 rounded-tr-lg rounded-bl-lg text-13px leading-none -tracking-0.18 bg-newsletterYellow-light",
                                                            children: item.title
                                                        })
                                                    }, item.slug);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Feedback/* default */.Z, {
                                                articleSlug: item1.slug
                                            })
                                        })
                                    ]
                                }),
                                showButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                    onClick: this.toggleContent,
                                    hidden: hidden
                                })
                            ]
                        })
                    ]
                }));
            }
        }
    ]);
    return ArticleCard;
}(react.Component);
/* harmony default export */ var Support_ArticleCard = (ArticleCard);


/***/ }),

/***/ 21260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Support_Feedback; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./lib/api/index.js
var api = __webpack_require__(2642);
// EXTERNAL MODULE: ./store/app/actions.js
var actions = __webpack_require__(27173);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
// EXTERNAL MODULE: ./components/Form/Radio.js
var Radio = __webpack_require__(13890);
;// CONCATENATED MODULE: ./containers/Support/FeedbackForm.js





var FeedbackForm = function(param1) {
    var submitFeedback = param1.submitFeedback;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
        onSubmit: submitFeedback,
        render: function(param) {
            var handleSubmit = param.handleSubmit, submitting = param.submitting;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit,
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block text-base mb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "feedback",
                            component: Radio/* default */.Z,
                            label: "Informatii mai usor de inteles",
                            type: "radio",
                            value: "Informatii mai usor de inteles"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "block text-base",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
                            name: "feedback",
                            component: Radio/* default */.Z,
                            label: "Informatii mai relevante",
                            type: "radio",
                            value: "Informatii mai relevante"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 mb-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            display: "inline",
                            disabled: submitting,
                            type: "submit",
                            title: "Trimite"
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var Support_FeedbackForm = (FeedbackForm);

;// CONCATENATED MODULE: ./containers/Support/Feedback.js







function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var Feedback = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(Feedback, Component1);
    var _super = _createSuper(Feedback);
    function Feedback() {
        _classCallCheck(this, Feedback);
        var _this;
        _this = _super.apply(this, arguments);
        _defineProperty(_assertThisInitialized(_this), "state", {
            vote: null,
            formIsActive: true
        });
        var _this1 = _assertThisInitialized(_this);
        _defineProperty(_assertThisInitialized(_this), "voteHandler", function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee(type) {
                var values, voteRes, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            values = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null;
                            _ctx.next = 3;
                            return (0,api/* submitSupportVoteApi */.Kiw)(type, _objectSpread({
                                article_slug: _this1.props.articleSlug,
                                category_slug: _this1.props.categorySlug
                            }, values ? {
                                form: values
                            } : null));
                        case 3:
                            voteRes = _ctx.sent;
                            if (voteRes.ok) {
                                _ctx.next = 7;
                                break;
                            }
                            _this1.props.addAlert({
                                message: "Nu s-a putut trimite mesajul. Te rugam sa incerci din nou.",
                                variant: "error"
                            });
                            return _ctx.abrupt("return", null);
                        case 7:
                            _this1.setState(_objectSpread({
                                vote: type
                            }, values ? {
                                formIsActive: false
                            } : null));
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(type) {
                return _ref.apply(this, arguments);
            };
        }());
        return _this;
    }
    _createClass(Feedback, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.articleSlug !== prevProps.articleSlug) {
                    this.setState({
                        vote: null,
                        formIsActive: true
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        (!this.state.vote || this.state.vote === "downvote") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center px-4 py-3 text-sm bg-newGray-light",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mr-2 -tracking-0.29",
                                    children: "Ti-a fost de ajutor acest raspuns?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return !_this.state.vote ? _this.voteHandler("upvote") : "";
                                        },
                                        className: "py-1 px-2 text-white bg-bleu sm:hover:bg-bleu-hover sm:focus:bg-bleu-active rounded outline-none",
                                        children: "Da"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ml-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        onClick: function() {
                                            return !_this.state.vote ? _this.voteHandler("downvote") : "";
                                        },
                                        type: "button",
                                        className: "py-1 px-2 text-white bg-bleu sm:hover:bg-bleu-hover sm:focus:bg-bleu-active rounded outline-none",
                                        children: "Nu"
                                    })
                                })
                            ]
                        }),
                        this.state.vote && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-5 text-sm\n            ".concat(this.state.vote === "downvote" ? "border-gray-1100 border-t" : "", "\n          "),
                            children: this.state.vote === "downvote" && this.state.formIsActive ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "block mb-3 text-black",
                                        children: "Cum putem imbunatati acest raspuns?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Support_FeedbackForm, {
                                        submitFeedback: function(values) {
                                            return _this.voteHandler("downvote", values);
                                        }
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "-traking-0.29",
                                children: "Iti multumim pentru feedback."
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return Feedback;
}(react.Component);
/* harmony default export */ var Support_Feedback = ((0,es/* connect */.$j)(null, {
    addAlert: actions/* addAlert */.V_
})(Feedback));


/***/ }),

/***/ 14666:
/***/ (function(module) {

module.exports = JSON.parse('["area","base","br","col","embed","hr","img","input","link","menuitem","meta","param","source","track","wbr"]');

/***/ })

}]);